import React from 'react';
import styled from 'styled-components';
import { Link } from 'gatsby';

import { Heading, Subtitle, SanityImage } from '../elements';

const CardWrapper = styled.div`
  border: 6px solid ${(props) => props.theme.borderColor};
  height: 100%;
`;

const InfoCard = ({ data }) => {
  if (!data) return null;
  return (
    <Link to={`/${data.linkTo ? data.linkTo.current : '#'}/`}>
      <CardWrapper className="card is-borderless">
        <div className="card-content">
          <div className="columns is-vcentered">
            {data.image && (
              <div className="column is-3">
                <figure className="image is-64x64 m-auto">
                  <SanityImage
                    alt={data.image.alt || 'Capextax'}
                    gatsbyImageId={data.image.asset.id}
                    width={200}
                  />
                </figure>
              </div>
            )}
            <div className="column is-9 has-text-centered-mobile">
              <Heading dark className="is-6">
                {data.title}
              </Heading>
              <Subtitle dark className="subtitle is-6">
                {data.subtitle}
              </Subtitle>
            </div>
          </div>
        </div>
      </CardWrapper>
    </Link>
  );
};

export default InfoCard;
